import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import FieldData from './FieldData';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { ClearIcon } from '@mui/x-date-pickers-pro';
import {
  setAllServices,
  setSearchFilter,
  setServiceForFilter,
  resetFilters,
  setItemsPerPage,
  setCurrentPage,
  setCategoryFilter,
} from 'src/redux/slices/servicesSlice';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import * as XLSX from 'xlsx';
import SearchImg from '../../assets/search.svg';
import Book1service from '../../assets/excel/Book1service.xlsx';
import { MdClear } from "react-icons/md";
// import { ClearIcon } from '@mui/x-date-pickers-pro';
import ServiceFilter from './ServiceFilter';
import BulkUploadServiceDialog from './components/BulkUploadServiceDialog'; 
import CategoryWiseServices from './components/CategoryWiseServices'; 
import CategoryIcon from '@mui/icons-material/Category';
import ListIcon from '@mui/icons-material/List';

const filterServiceFor = [
  { value: 'Female', label: 'Female' },
  { value: 'Male', label: 'Male' },
  { value: 'Both', label: 'Both' },
];

const AllServices = () => {
  const dispatch = useDispatch();
  const [checkedServices, setCheckedServices] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [viewMode, setViewMode] = useState('list'); // 'list' | 'categories'
  const [categoryData, setCategoryData] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadedData, setUploadedData] = useState(null);
  const { fetchAllServices, activeBranchId, createManyService, setShowMessage, deleteManyService , getAppointmentPageData } = useMain();

  const newData = useSelector((state) => state.service.services);
  const filteredData = useSelector((state) => state.service.filteredServices);
  const filter = useSelector((state) => state.service.filters);
  const pagination = useSelector((state) => state.service.pagination);

  useEffect(() => {
    getData();
  }, [activeBranchId]);

  useEffect(() => {
    dispatch(setAllServices(newData)); // Update the services data
  }, [newData]);

   useEffect(() => {
      dispatch(resetFilters()); 
    }, []);
  useEffect(() => {
    if (viewMode === 'categories' && activeBranchId) {
      loadCategoryData();
    }
  }, [viewMode, activeBranchId]);

  const loadCategoryData = async () => {
    setCategoryLoading(true);
    try {
      const res = await getAppointmentPageData(activeBranchId);
      if (res?.statusCode === 200) {
        setCategoryData(res.data?.services || []); // .services is the categorizedServicesArray
      } else {
        setShowMessage({ message: res?.message || 'Failed to load categories', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setCategoryLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet);
         // console.log(jsonData,"jsonDataaa")
        // setUploadedData(jsonData);
        // Map Excel columns to database keys, supporting both camelCase and Space Case headers
        const formattedData = jsonData.map((item) => ({
          serviceName: item.serviceName || item['serviceName'],
          category: item.category || item['category'],
          price: item.price || item['price'],
          duration: item.duration || item['duration'],
          serviceFor: item.serviceFor || item['serviceFor'],
          taxStatus: (item.taxStatus || item['taxStatus']) === 'Exclusive' ? 'withoutTax' : (item.taxStatus || item['taxStatus']) === 'Inclusive' ? 'withTax' : 'noGst',
          reminderDays: item.reminderDays || item['reminderDays'],
        }));
        setUploadedData(formattedData);
      };
      reader.readAsArrayBuffer(selectedFile);
    }
  };

  const handleBulkDelete = async () => {
    setOpenDialogue(true);
  };

  const getData = async () => {
    try {
      setShowLoader(true);
      const res = await fetchAllServices(activeBranchId);
      if (res.statusCode === 200) {
        dispatch(setAllServices(res?.data));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowLoader(false);
    }
  };

  // Remove only leading spaces while typing (spaces between words still work)
  const handleSearchChange = (e) => {
    dispatch(setSearchFilter((e.target.value || '').trimStart()));
  };

  // Trims the pasted text, then inserts it at the cursor position
  const handleSearchPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').trim();
    const { selectionStart, selectionEnd, value } = e.target;
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    dispatch(setSearchFilter(next));
  };

  // Trims trailing spaces when the user leaves the box
  const handleSearchBlur = (e) => {
    const trimmed = e.target.value.trim();
    if (trimmed !== e.target.value) {
      dispatch(setSearchFilter(trimmed));
    }
  };

  const handleGenderChange = (e) => {
    dispatch(setServiceForFilter(e.target.value)); // Update gender filter
  };

  const handleLimitChange = (e) => {
    dispatch(setItemsPerPage(e.target.value)); // Update limit
  };

  const handlePageChange = (e, page) => {
    dispatch(setCurrentPage(page)); // Update the current page
  };


  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (uploadedData) {
      setShowLoader(true);
      try {
        const res = await createManyService(activeBranchId, { bulkData: uploadedData });
        setShowMessage({
          message: res?.statusCode === 200 ? 'Service was successfully uploaded' : 'Service failed to upload',
          messageType: res?.statusCode === 200 ? 'success' : 'error',
        });
        getData();
      } catch (error) {
        setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
      } finally {
        setShowLoader(false);
        closeModal();
      }
    }
  };

  const downloadExcelTemplate = () => {
    //code for old gst
    // const templateFileName = Book1service;
    // // Create an anchor element to trigger the download
    // const a = document.createElement('a');
    // a.style.display = 'none';
    // a.href = templateFileName;
    // a.download = 'service_template.xlsx';
    // // Trigger the click event to download the file
    // document.body.appendChild(a);
    // a.click();
    // // Remove the anchor element
    // document.body.removeChild(a);
    const headers = [
      "serviceName",
      "category",
      "price",
      "duration",
      "serviceFor",
      "taxStatus",
      "reminderDays"
    ];

    const sampleData = [
      {
        "serviceName": "Hair Cut",
        "category": "Hair",
        "price": 500,
        "duration": 30,
        "serviceFor": "Male",
        "taxStatus": "Inclusive",
        "reminderDays": "10",
      },
      {
        "serviceName": "Skin Treatment",
        "category": "Skin",
        "price": 2000,
        "duration": 60,
        "serviceFor": "Female",
        "taxStatus": "Exclusive",
        "reminderDays": "35",
      },
    ];

    const ws = XLSX.utils.json_to_sheet(sampleData, { header: headers });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Services");
    XLSX.writeFile(wb, "service_template.xlsx");
        closeModal();
  };


  const submitBulkDelete = async () => {
    try {
      setDeleteLoading(true);
      const serviceIds = checkedServices.map(service => service?._id);
      const payload = {
        ids: serviceIds,
      };

      const response = await deleteManyService(payload, activeBranchId);

      if (response.statusCode === 200) {
        setShowMessage({ message: 'Successfully deleted Services', messageType: 'success' });
        setCheckedServices([]);
        getData();
      } else {
        setShowMessage({ message: response.message || 'Error occurred while deleting Services', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setDeleteLoading(false);
      setOpenDialogue(false);
    }
  };

  return (
<PageContainer title="Manage Services" description="this contains all products">
  <DashboardCard2 title="Manage Services">
     {/* Row 1 — Tab toggle, on its own line above everything else */}
        <div style={{ display: 'flex', marginBottom: '1rem' }}>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(e, newMode) => newMode && setViewMode(newMode)}
            sx={{
              borderRadius: '30px',
              height: '40px',
              backgroundColor: '#f0f0f0',
              border: '1px solid #cfcece',
              display: 'flex',
              gap: '2px',
            }}
          >
            <ToggleButton
              value="list"
              sx={{
                color: '#000',
                backgroundColor: '#fafafa',
                padding: '0 20px',
                borderRadius: '30px',
                border: 'none',
                '&.Mui-selected': {
                  backgroundColor: '#6174DD',
                  color: '#fff',
                  border: 'none',
                  '&:hover': {
                    backgroundColor: '#6174DD',
                  },
                },
                '&:not(.Mui-selected)': {
                  '&:hover': {
                    backgroundColor: '#d0d0d0',
                  },
                },
              }}
            >
              By Service
            </ToggleButton>
            <ToggleButton
              value="categories"
              sx={{
                color: '#000',
                backgroundColor: '#fafafa',
                padding: '0 20px',
                borderRadius: '30px',
                border: 'none',
                '&.Mui-selected': {
                  backgroundColor: '#6174DD',
                  color: '#fff',
                  border: 'none',
                  '&:hover': {
                    backgroundColor: '#6174DD',
                  },
                },
                '&:not(.Mui-selected)': {
                  '&:hover': {
                    backgroundColor: '#d0d0d0',
                  },
                },
              }}
            >
              By Category
            </ToggleButton>
          </ToggleButtonGroup>
        </div>

        {/* Row 2 — Show per page / Search / Filter / Upload-Delete (unchanged, as it was originally) */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-end', 
          marginBottom: '1.7rem' 
        }}>
          {/* Left side - Show per page */}
          <div>
            <InputLabel>Show per page</InputLabel>
            <Select
              style={{ 
                borderRadius: '7px', 
                border: '0.5px solid #6174DD', 
                padding: '4px 12px', 
                background: '#FFF', 
                height: '40px',
                width: '100px'
              }}
              value={pagination.itemsPerPage}
              onChange={handleLimitChange}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={200}>200</MenuItem>
            </Select>
          </div>

          {/* Right side - Search, Filter and Upload/Delete button */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'flex-end', 
            gap: '0.8rem'
          }}>
            {/* Search */}
            <div style={{ width: '170px', flexShrink: 0 }} onClick={() => document.getElementById('search-input').focus()}>
              <InputLabel>Search</InputLabel>
              <div 
                className="search-input" 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  border: '0.5px solid #6174DD',
                  borderRadius: '7px',
                  padding: '4px 12px',
                  background: '#FFF',
                  height: '40px',
                  width: '100%',
                  maxWidth: 'none',
                  boxSizing: 'border-box',
                  marginBottom:'2px'
                }}
              >
                <img src={SearchImg} alt="" style={{ marginRight: '8px' }} />
                <input
                  id="search-input"
                  type="text"
                  placeholder="Search Services..."
                  value={filter.search || ''}
                  onChange={handleSearchChange}
                  onPaste={handleSearchPaste}
                  onBlur={handleSearchBlur}
                  style={{ 
                    flex: 1, 
                    border: 'none', 
                    outline: 'none',
                    background: 'transparent',
                    height: '100%'
                  }}
                />
                {filter.search && (
                  <IconButton
                    onClick={() => dispatch(setSearchFilter(''))}
                    style={{ padding: 1 }}
                  >
                    <ClearIcon style={{
                                      color: '#000',
                                      marginRight: '-0.2rem',
                                      marginTop: '0.1rem',
                                      fontSize: '1.1rem'
                                    }} />
                  </IconButton>
                )}
              </div>
            </div>

            {/* Filter */}
            <div style={{marginTop:'0px'}}>
              <ServiceFilter
                services={newData}
                value={[
                  ...(filter.serviceFor ? [filter.serviceFor] : []),
                  ...(filter.category ? [filter.category] : []),
                  ...(filter.search ? [filter.search] : []),
                ]}
                onChange={(selectedValues) => {
                  const genders = selectedValues.filter((val) => ['Female', 'Male', 'Both'].includes(val));
                  const categories = selectedValues.filter((val) => newData.some((s) => s.category === val));
                  const serviceNames = selectedValues.filter((val) => newData.some((s) => s.serviceName === val));

                  dispatch(setServiceForFilter(genders.length > 0 ? genders[0] : ''));
                  dispatch(setCategoryFilter(categories.length > 0 ? categories[0] : ''));
                  dispatch(setSearchFilter(serviceNames.length > 0 ? serviceNames[0] : ''));
                }}
                placeholder="Filters"
              />
            </div>

            {/* Upload/Delete Button */}
            <div style={{marginBottom:'1px', display: 'flex', gap: '0.8rem'}}>
              {checkedServices.length ? (
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ 
                    background: '#ff4d4d', 
                    height: '40px',
                    minWidth: '120px',
                    '&:hover': { 
                      background: '#ff6666' 
                    } 
                  }}
                  onClick={handleBulkDelete}
                >
                  Delete
                </Button>
              ) : (
                <BulkUploadServiceDialog
                  onUploaded={getData}
                  existingServices={newData}
                />
              )}
            </div>
          </div>
        </div>


    {/* Modal Dialog */}
    <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>Create Many Services</DialogTitle>
      <form onSubmit={handleFormSubmit}>
        <Box p={2}>
          <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
        </Box>
        {showLoader && <ShowLoader />}
        <Box p={2}>
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
          <Button variant="outlined" color="primary" sx={{ ml: 2 }} onClick={downloadExcelTemplate}>
            <ArrowCircleDownIcon sx={{ margin: '0px 2px 0px 0px' }} />
            Sample Download
          </Button>
        </Box>
      </form>
    </Dialog>

    {/* Delete Dialog */}
    <Dialog open={openDialogue} onClose={() => setOpenDialogue(false)}>
      <DialogTitle>Delete service</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to delete this Service?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenDialogue(false)}>Cancel</Button>
        <Button onClick={submitBulkDelete} autoFocus>Delete</Button>
      </DialogActions>
    </Dialog>

 {viewMode === 'categories' ? (
      categoryLoading ? (
        <ShowLoader />
      ) : (
        <CategoryWiseServices data={categoryData} activeBranchId={activeBranchId} />
      )
    ) : showLoader ? (
            <ShowLoader />
    ) : filteredData.length > 0 ? (
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FieldData
              data={filteredData}
              getServices={getData}
              setCheckedServices={setCheckedServices}
              checkedServices={checkedServices}
            />
          </Grid>
        </Grid>
      </Box>
    ) : (
      'No data found'
    )}

    {viewMode === 'list' && (
      <Box display={'flex'} justifyContent={'flex-end'} mt={2}>
        <Pagination 
          count={pagination.totalPages} 
          page={pagination.currentPage} 
          color="primary" 
          onChange={handlePageChange} 
        />
      </Box>
    )}
  </DashboardCard2>
</PageContainer>
  );
};

export default AllServices;